import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/map";
import { futureSite, Site, GeoSite } from "../../interface/site";
import { LocationMaster } from "../../interface/location-master";
import { Country } from "../../interface/country";

@Injectable()
export class SiteService {
  siteAction = new Subject();
  constructor(private router: Router, private httpClient: HttpClient) { }

  create(siteForm): Observable<any> {
    let body = siteForm;
    return this.httpClient.post("site", body);
  }

  list(filter = ""): Observable<Site[]> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<Site[]>("site" + filter);
  }

  delete(siteId): Observable<any> {
    return this.httpClient.delete("site/" + siteId);
  }

  locationMasterList(): Observable<LocationMaster[]> {
    return this.httpClient.get<LocationMaster[]>("location/master");
  }

  update(siteForm): Observable<any> {
    let body = siteForm;
    return this.httpClient.patch("site", body);
  }

  getAction(): Observable<any> {
    return this.siteAction.asObservable();
  }

  sendAction(action, data) {
    this.siteAction.next({ action: action, data: data })
  }

  getOperationHr(postBody): Observable<any> {
    return this.httpClient.post("site/operationSite", postBody);
  }

  scheduledSiteList(id): Observable<futureSite[]> {
    return this.httpClient.get<futureSite[]>('site/futureSite/' + id);
  }

  updateFutureSite(form): Observable<any> {
    let body = form;
    return this.httpClient.patch('site/futureSite/', body);
  }

  deleteFutureSite(id) {
    return this.httpClient.delete('site/futureSite/' + id);
  }

  listGeoSites(): Observable<GeoSite[]> {
    return this.httpClient.get<GeoSite[]>("geosite");
  }

  countryList(): Observable<Country[]> {
    return this.httpClient.get<Country[]>("site/country");
  }

  getSiteList(filter = ""): Observable<Site[]> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<Site[]>("site/list" + filter);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/site/site.service.ts